(function () {
  'use strict';

  /* ============================================================
     Line-item discount tags — inject a visible badge on the cart
     item image based on the applied discounts (or free item).
     ============================================================ */
  function detectTag(discountTexts, finalPrice, originalPrice) {
    // v2: las etiquetas 3x2 / Gratis ahora se pintan en Liquid (cart-drawer.liquid).
    return null;
    var joined = discountTexts.join(' ').toLowerCase();
    if (finalPrice === 0 && originalPrice > 0) {
      return { cls: 'ls-line-tag--free', label: 'Gratis' };
    }
    if (joined.indexOf('3x2') !== -1 || joined.indexOf('3 x 2') !== -1) {
      return { cls: 'ls-line-tag--3x2', label: '3×2' };
    }
    if (joined.indexOf('clases10') !== -1 || joined.indexOf('10%') !== -1) {
      return { cls: 'ls-line-tag--pct', label: '10% OFF' };
    }
    if (discountTexts.length > 0) {
      var pct = originalPrice > 0 ? Math.round((1 - finalPrice / originalPrice) * 100) : 0;
      return { cls: 'ls-line-tag--pct', label: pct > 0 ? '-' + pct + '%' : 'DESC' };
    }
    return null;
  }

  function readItemState(row) {
    var discountEls = row.querySelectorAll('.discounts .discounts__discount');
    var texts = Array.from(discountEls).map(function (el) { return el.textContent.trim(); });
    var oldPriceEl = row.querySelector('.cart-item__totals .cart-item__old-price');
    var currentPriceEl = row.querySelector('.cart-item__totals .price:not(.cart-item__old-price)');
    function parseMoney(el) {
      if (!el) return null;
      var m = el.textContent.replace(/[^0-9.,]/g, '').replace(/\./g, '').replace(',', '.');
      var n = parseFloat(m);
      return isNaN(n) ? null : n;
    }
    return { texts: texts, oldPrice: parseMoney(oldPriceEl) || 0, finalPrice: parseMoney(currentPriceEl) || 0 };
  }

  function applyLineTag(row) {
    var media = row.querySelector('.cart-item__media');
    if (!media) return;
    var existing = media.querySelector('.ls-line-tag');
    var st = readItemState(row);
    var tag = detectTag(st.texts, st.finalPrice, st.oldPrice);
    if (!tag) {
      if (existing) existing.remove();
      return;
    }
    var newClass = 'ls-line-tag ' + tag.cls;
    // Idempotent: skip DOM mutation when the tag is already correct.
    // Without this, the MutationObserver on cart-drawer would re-trigger
    // itself on every remove/append and freeze the page ("página no responde").
    if (existing && existing.className === newClass && existing.textContent === tag.label) {
      return;
    }
    if (existing) existing.remove();
    var span = document.createElement('span');
    span.className = newClass;
    span.textContent = tag.label;
    media.appendChild(span);
  }

  function refreshTags() {
    document.querySelectorAll('cart-drawer .cart-item, #main-cart-items .cart-item').forEach(applyLineTag);
  }

  /* Some section swaps rename the drawer form to id="cart" — the Finalizar
     Compra button references form="CartDrawer-Form". Repair it if needed. */
  function repairCheckoutForm() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var byId = document.getElementById('CartDrawer-Form');
    if (byId) return;
    var candidate = drawer.querySelector('form#cart') || drawer.querySelector('form');
    if (candidate) candidate.id = 'CartDrawer-Form';
  }

  /* Safety net: rescue any /cart/add form submit whose hidden id input is
     still `disabled` (Dawn ships it disabled and enables it via product-form.js
     — if that script hasn't run yet the browser strips the id and Shopify
     returns "Required parameter missing or invalid: items"). Enable the input
     just before submit so the value goes through. */
  function handleFormSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = (form.getAttribute('action') || '').split('?')[0];
    if (!/\/cart\/add(?:\.js)?$/.test(action)) return;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.disabled && idInput.value) {
      idInput.disabled = false;
    }
    var idVal = idInput && idInput.value;
    if (!idVal) {
      e.preventDefault();
      e.stopPropagation();
      var msgEl = form.querySelector('.product-form__error-message');
      if (msgEl) {
        msgEl.textContent = 'Selecciona una variante antes de agregar.';
        var wrap = form.closest('product-form') && form.closest('product-form').querySelector('.product-form__error-message-wrapper');
        if (wrap) wrap.removeAttribute('hidden');
      } else {
        try { alert('Selecciona una variante antes de agregar.'); } catch (er) {}
      }
    }
  }

  /* Safety net: if a user clicks "Finalizar Compra" and the referenced form
     isn't there, redirect straight to /checkout. */
  function handleCheckoutClick(e) {
    var btn = e.target.closest('#CartDrawer-Checkout, [name="checkout"]');
    if (!btn) return;
    if (!btn.closest('cart-drawer')) return;
    var formId = btn.getAttribute('form');
    var form = formId ? document.getElementById(formId) : btn.closest('form');
    if (!form) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'checkout';
    }
  }

  /* ============================================================
     Upsell add-to-cart — intercept the form, AJAX-add, then ask
     the cart drawer to re-render (matches theme's cart-drawer.js).
     ============================================================ */
  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve();
    var sections;
    if (typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (s) { return s.section || s.id; }).filter(Boolean);
      if (!sections.length) sections = ['cart-drawer', 'cart-icon-bubble'];
    } else {
      sections = ['cart-drawer', 'cart-icon-bubble'];
    }
    return fetch('/?sections=' + encodeURIComponent(sections.join(',')))
      .then(function (r) { return r.json(); })
      .then(function (json) {
        sections.forEach(function (name) {
          if (!json[name]) return;
          var parser = new DOMParser();
          var doc = parser.parseFromString(json[name], 'text/html');
          if (name === 'cart-drawer') {
            var freshDrawer = doc.querySelector('cart-drawer');
            var liveDrawer = document.querySelector('cart-drawer');
            if (freshDrawer && liveDrawer) {
              liveDrawer.innerHTML = freshDrawer.innerHTML;
              if (freshDrawer.classList.contains('is-empty')) liveDrawer.classList.add('is-empty');
              else liveDrawer.classList.remove('is-empty');
            }
          } else {
            var host = document.getElementById(name);
            var fresh = doc.getElementById(name) || doc.querySelector('#' + name);
            if (host && fresh) host.innerHTML = fresh.innerHTML;
          }
        });
      })
      .catch(function () {});
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    drawer.classList.remove('is-empty');
    drawer.setAttribute('open', '');
  }

  function handleUpsellSubmit(e) {
    var btn = e.target.closest('[data-ls-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    var id = btn.dataset.variantId || (btn.closest('form') && btn.closest('form').querySelector('[name="id"]').value);
    if (!id) return;
    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Agregando…';

    var drawer = document.querySelector('cart-drawer');
    var sectionList = [
      { id: 'CartDrawer', section: 'cart-drawer', selector: null },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: null },
    ];
    var sectionNames = ['cart-drawer', 'cart-icon-bubble'];
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var body = {
      items: [{ id: parseInt(id, 10), quantity: 1 }],
      sections: sectionNames.join(','),
      sections_url: window.location.pathname,
    };

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw j;
          return j;
        });
      })
      .then(function (json) {
        if (json.sections) {
          sectionList.forEach(function (s) {
            var html = json.sections[s.section];
            if (!html) return;
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            if (s.section === 'cart-drawer') {
              var freshDrawer = doc.querySelector('cart-drawer');
              var liveDrawer = document.querySelector('cart-drawer');
              if (freshDrawer && liveDrawer) {
                liveDrawer.innerHTML = freshDrawer.innerHTML;
                liveDrawer.classList.remove('is-empty');
              }
            } else {
              var host = document.getElementById(s.id) || document.getElementById(s.section);
              var freshEl = doc.getElementById(s.id) || doc.getElementById(s.section);
              if (host && freshEl) host.innerHTML = freshEl.innerHTML;
            }
          });
        }
        openDrawer();
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ls-upsell', productVariantId: id, cartData: json });
          }
        } catch (ev) {}
        btn.textContent = origText;
        btn.disabled = false;
        refreshTags();
        initCarousels();
        repairCheckoutForm();
      })
      .catch(function (err) {
        console.error('[LS-Upsell] add-to-cart failed', err);
        btn.textContent = err && err.description ? err.description.slice(0, 20) : 'Error';
        setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 1800);
      });
  }

  /* ============================================================
     Carousel — auto-rotate promo chips
     ============================================================ */
  function initCarousels(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-ls-carousel]').forEach(function (car) {
      if (car.__lsCarouselInit) return;
      car.__lsCarouselInit = 1;
      var slides = car.querySelectorAll('.ls-cro-carousel__slide');
      var dots = car.querySelectorAll('.ls-cro-carousel__dot');
      if (slides.length < 2) return;
      var interval = parseInt(car.dataset.interval, 10) || 2000;
      var i = 0;
      var timer = setInterval(function () {
        slides[i].classList.remove('is-active');
        if (dots[i]) dots[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
        if (dots[i]) dots[i].classList.add('is-active');
      }, interval);
      car.__lsCarouselTimer = timer;
    });
  }

  /* ============================================================
     Bootstrap
     ============================================================ */
  function bindObservers() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.__lsCROObserved) {
      drawer.__lsCROObserved = 1;
      // Throttle: run at most once per animation frame to prevent
      // observer-triggered mutations from feedback-looping the page.
      var pending = false;
      var obs = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          refreshTags();
          initCarousels();
          repairCheckoutForm();
        });
      });
      obs.observe(drawer, { childList: true, subtree: true });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refreshTags(); repairCheckoutForm(); }); } catch (e) {}
    }
    // Delegated upsell add-to-cart
    if (!document.body.__lsCROBound) {
      document.body.__lsCROBound = 1;
      document.body.addEventListener('click', handleUpsellSubmit, true);
      document.body.addEventListener('click', handleCheckoutClick, true);
      document.body.addEventListener('submit', handleFormSubmit, true);
    }
  }

  window.LSRefreshCartDrawer = refreshCartDrawer;

  function init() {
    refreshTags();
    initCarousels();
    repairCheckoutForm();
    bindObservers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', refreshTags);
})();
